export const delivery_details_form_constant = {
    basic_details: {
        title: "Delivery Details",
        form_fields: {
            delivery_address: {
                field_name: "delivery_address",
                placeholder: "Delivery Address",
            },
            delivery_pin_code: {
                field_name: "delivery_pin_code",
                placeholder: "Pin Code",
            },
            delivery_state: {
                field_name: "delivery_state",
                placeholder: "State",
            },
            delivery_city: {
                field_name: "delivery_city",
                placeholder: "City",
            },
        },
    },
};
